import { SizeType } from '@config/type'
import cn from 'classnames'

import { ReactComponent as SupportIcon } from './assets/img/logo.svg'

import styles from './logo-support.module.css'

interface LogoSupportProps extends React.ComponentPropsWithoutRef<'svg'> {
  size?: SizeType
  type?: 'primary' | 'secondary' | 'accent'
  disabled?: boolean
}

export const LogoSupport = ({
  className,
  type = 'primary',
  size = 'sm',
  disabled
}: LogoSupportProps) => {
  return (
    <SupportIcon
      className={cn(styles.container, className, {
        [styles.primary]: type === 'primary',
        [styles.secondary]: type === 'secondary',
        [styles.accent]: type === 'accent',
        [styles.sm]: size === 'sm',
        [styles.md]: size === 'md',
        [styles.lg]: size === 'lg',
        [styles.xl]: size === 'xl',
        [styles.disabled]: disabled
      })}
    ></SupportIcon>
  )
}
